import Stack from "../services/contentstack";

export const getPageRes = async (entryUrl, referenceFieldPath, jsonRtePath) => {
    const response = await Stack.getEntryByUrl({
      contentTypeUid: 'page',
      entryUrl,
      referenceFieldPath: referenceFieldPath || [],
      jsonRtePath: jsonRtePath || [],
    });
    // liveEdit && addEditableTags(response[0], 'page', true);
    return response[0];
  };